/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react'
import React from 'react'

const defaultMaxWidth = '82rem'
const Container = ({ children, maxWidth }) => {
  maxWidth = maxWidth || defaultMaxWidth
  const style = css`
    height: 100%;
    max-width: ${maxWidth};
    margin: 0 auto;
    // min-height: 100%;

    @media (max-width: 88rem) {
      padding: 0 0.8rem;
    }
  `

  return (
    <div css={style} className="container">
      {children}
    </div>
  )
}

export default Container
